import { DqSocketContextData, DqSocketProvider, DqSocketProviderProps } from 'src/utils/socket';
import React, { PropsWithChildren } from 'react';
import APIS from '../../apiUrl';
import { SocketClient } from '../SocketClient';

export const SocketContextSentinel = React.createContext<DqSocketContextData>(undefined!);

export const socketClientSentinel = new SocketClient(APIS.SENTINEL_API);

export const SocketContextSentinelProvider: React.FC<
  PropsWithChildren<Omit<DqSocketProviderProps, 'client' | 'Context'>>
> = props => {
  return (
    <DqSocketProvider {...props} Context={SocketContextSentinel} client={socketClientSentinel}>
      {props.children}
    </DqSocketProvider>
  );
};
